export interface ISessionHeartBeatResponse {
  apiCallSuccess: boolean;
  sessionOk: boolean;
  apiCallErrorMsg: string;
}
export default abstract class {
  public abstract doSessionHearBeat(): Promise<ISessionHeartBeatResponse>;
}
